import styled from 'styled-components'

export const Legend = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const LegendPillTip = styled.div<{ $direction: 'up' | 'down' }>`
  border: 1px solid #abbed1;
  border-radius: ${({ $direction }) =>
    $direction === 'up' ? `20px 20px 0 0` : `0 0 20px 20px`};
  width: ${({ theme }) => `${theme.saf.pillWidth}px`};
  height: 20px;
  background: #fff;
`

export const LegendStockBox = styled.div`
  position: relative;
  border: 1px solid #abbed1;
  width: ${({ theme }) => `${theme.saf.pillWidth}px`};
  height: 20px;
  background: #fff;

  > svg {
    transform: translate3d(-4px, -2px, 0);
  }
`

export const LegendGrid = styled.div`
  display: grid;
  grid-template-columns: auto auto auto 1fr;
  gap: 2px;
  align-items: center;

  > :nth-child(4n + 1) {
    text-align: right;
  }
`
